var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9884 20.3962H8.01177C3.51094 20.3962 1.58594 18.4712 1.58594 13.9704V13.8512C1.58594 9.78124 3.1901 7.81958 6.78344 7.48041C7.1501 7.45291 7.49844 7.72791 7.5351 8.10374C7.57177 8.47958 7.29677 8.81874 6.91177 8.85541C4.03344 9.12124 2.96094 10.4779 2.96094 13.8604V13.9796C2.96094 17.7104 4.28094 19.0304 8.01177 19.0304H13.9884C17.7193 19.0304 19.0393 17.7104 19.0393 13.9796V13.8604C19.0393 10.4596 17.9484 9.10291 15.0151 8.85541C14.6393 8.81874 14.3551 8.48874 14.3918 8.11291C14.4284 7.73708 14.7493 7.45291 15.1343 7.48958C18.7826 7.80124 20.4143 9.77208 20.4143 13.8696V13.9887C20.4143 18.4712 18.4893 20.3962 13.9884 20.3962Z",
    fill: "#0E0C0B",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.3272C10.6242 14.3272 10.3125 14.0155 10.3125 13.6397V1.83301C10.3125 1.45717 10.6242 1.14551 11 1.14551C11.3758 1.14551 11.6875 1.45717 11.6875 1.83301V13.6397C11.6875 14.0247 11.3758 14.3272 11 14.3272Z",
    fill: "#0E0C0B",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 15.3537C10.826 15.3537 10.6518 15.2895 10.5143 15.152L7.44352 12.0812C7.17768 11.8154 7.17768 11.3754 7.44352 11.1095C7.70935 10.8437 8.14935 10.8437 8.41518 11.1095L11.0002 13.6945L13.5852 11.1095C13.851 10.8437 14.291 10.8437 14.5568 11.1095C14.8227 11.3754 14.8227 11.8154 14.5568 12.0812L11.486 15.152C11.3485 15.2895 11.1743 15.3537 11.0002 15.3537Z",
    fill: "#0E0C0B",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.624ea6619aad8660e9644d34dd3f00bf.svg";
export { ForwardRef as ReactComponent };